<div fxLayout="column" fxFill>
  <div [fxFlex]="typeCes == typeCesEnum.SHOW ? '90' : '70'" class="items">
    <table mat-table #table [dataSource]="dataSource" class="mat-elevatio-4">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>CÓDIGO</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="i == indexSelect ? '' : 'code'"
        >
          {{ element.code }}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>TIPO</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="i == indexSelect ? '' : 'type'"
        >
          {{ element.type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="system">
        <th mat-header-cell *matHeaderCellDef>SISTEMA</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="i == indexSelect ? '' : 'system'"
        >
          {{ element?.system?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="terminalQuantity">
        <th mat-header-cell *matHeaderCellDef>QTD. TERM.</th>
        <td mat-cell *matCellDef="let element">
          {{ element.terminalQuantity }}
        </td>
      </ng-container>

      <ng-container matColumnDef="monthlyValue">
        <th mat-header-cell *matHeaderCellDef>MENSALIDADE</th>
        <td mat-cell *matCellDef="let element">
          {{ element.monthlyValue | currency : "BRL" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef>VENCIMENTO</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dueDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="adhesionFee">
        <th mat-header-cell *matHeaderCellDef>TX. ADESÃO</th>
        <td mat-cell *matCellDef="let element">
          {{ element.adhesionFee | currency : "BRL" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="daysCountQuantity">
        <th mat-header-cell *matHeaderCellDef title="QUANTIDADE DIAS CORRIDOS">
          QT. DIAS CORR.
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.daysCountQuantity }}
        </td>
      </ng-container>

      <ng-container matColumnDef="daysCountValue">
        <th mat-header-cell *matHeaderCellDef title="VALOR DIAS CORRIDOS">
          VR. DIAS CORR.
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.daysCountValue | currency : "BRL" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deploymentValue">
        <th mat-header-cell *matHeaderCellDef>VR. IMPLANTAÇÃO</th>
        <td mat-cell *matCellDef="let element">
          {{ element.deploymentValue | currency : "BRL" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="createdAt">CRIADO EM</th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef class="status">SITUAÇÃO</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="i == indexSelect ? 'status-selected' : 'status'"
        >
          <mat-icon *ngIf="element.active" class="item-icon-active"
            >check</mat-icon
          >
          <mat-icon *ngIf="!element.active" class="item-icon-inactive"
            >close</mat-icon
          >
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="table-row"
      ></tr>
      <tr
        tabindex="999"
        #rowDef
        mat-row
        *matRowDef="let row; columns: displayedColumns; let i = index"
        [ngClass]="getNgClass(dataSource.data[i], i)"
        (click)="select(row, i)"
        [class.demo-row-is-clicked]="indexSelect === i"
        class="table-row"
      ></tr>
    </table>
  </div>
</div>
